import * as React from "react";
import { connect } from "react-redux";
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import { getURLPath } from '../../helpers/Tools';
import { getFirstName, queryParams } from "../../helpers/formatting";
import * as types from "../../constants/actionTypes";
import Spinner from "../common/spinner";
import StaticHtmlContent from "../common/staticHtmlContent";
import { Tooltip } from 'reactstrap';

import * as queryString from 'query-string';

class ScheduleVaccineLanding extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isGeoAddressFetch: false,
            isAcceptTermsSelected: false,
            isError: false,
            antibodyTooltipOpen: false,
            componentTooltipOpen: false,
            reactionTooltipOpen: false,
            tooltipOpen: false
        };
        const { location } = this.props;
        this.toggleAntibodyTooltip = this.toggleAntibodyTooltip.bind(this);
        this.toggleComponentsTooltip = this.toggleComponentsTooltip.bind(this);
        this.toggleReactionTooltip = this.toggleReactionTooltip.bind(this);
        this.acceptTermsSelectedToggle = this.acceptTermsSelectedToggle.bind(this);
        this.onScheduleClick = this.onScheduleClick.bind(this);
        this.findXidFromProxyList = this.findXidFromProxyList.bind(this);
        this.findImmunizationIndexForPatient = this.findImmunizationIndexForPatient.bind(this);
        this.getVaccineShotInformation = this.getVaccineShotInformation.bind(this);

        this.userLocation = 'Waco, TX';
        const searchParams = (location && location.search && queryString.parse(location.search)) || null;
        //Looks at props for xid.  If no props, looks at url string.  If nothing, sets to null
        this.EIdByParams = this.props.xid ? this.props.xid : searchParams && searchParams["?xid"] ? searchParams["?xid"] : searchParams && searchParams["xid"] ? searchParams["xid"] : null;

    }

    componentDidMount() {
        const { isLoggedIn, userName, getUserAddress, latitude, longitude, curPosLatitude, curPosLongitude, cityAddress, stateAddress } = this.props;

        //debugger;
        if (!curPosLatitude && !curPosLongitude && !cityAddress && !stateAddress) {
            if (latitude && longitude) {
                this.setState({ isGeoAddressFetch: true });
            }

            if (isLoggedIn && userName && !latitude && !longitude) {
                getUserAddress(userName);
            }
        }

        this.getLocation();

        logUI("MBHWeb.UI.ScheduleVaccineLanding.ComponentDidMount", new Date(), getURLPath());
    }

    componentDidUpdate(prevProps) {
        const { waitingOnGeoAddress, geoAddressError, cityAddress, stateAddress } = this.props;
        const { isGeoAddressFetch, loading } = this.state;

        //debugger;
        if (isGeoAddressFetch && !waitingOnGeoAddress && loading) {
            if (geoAddressError && geoAddressError !== "") {
                this.redirectToFindCare();
            } else if (cityAddress && stateAddress) {
                this.redirectToFindCare();
            }
        }
    }

    getVaccineShotInformation(covidImmunizations, currentUser) {
        let vaccineShotHistory = {
            maxVaccineShots: 0,
            currentVaccineShots: 0
        };

        if (covidImmunizations && covidImmunizations.length > 0) {
            const index = this.findImmunizationIndexForPatient(covidImmunizations, currentUser);
            if (index !== false && Number.isFinite(index)) {
                const maxVaccineShots = covidImmunizations[index].manufacturer && covidImmunizations[index].manufacturer.length > 0 ? covidImmunizations[index].manufacturer[0].maxShots : 0;
                const currentVaccineShots = covidImmunizations[index].manufacturer && covidImmunizations[index].manufacturer.length > 0 ? covidImmunizations[index].manufacturer[0].totalShotsTaken : 0;

                vaccineShotHistory.maxVaccineShots = maxVaccineShots;
                vaccineShotHistory.currentVaccineShots = currentVaccineShots;
            }
        }

        return vaccineShotHistory;
    }

    findImmunizationIndexForPatient(covidImmunizations, currentUser) {
        if (covidImmunizations && covidImmunizations.length > 0 && currentUser && currentUser.eid) {
            for (let index = 0; index < covidImmunizations.length; index++) {
                const patientIds = covidImmunizations[index].patient && covidImmunizations[index].patient && covidImmunizations[index].patient.patientIds ? covidImmunizations[index].patient.patientIds : false;
                const immunizationPatientArray = patientIds.filter(info => info.id.includes(currentUser.eid));
                if (immunizationPatientArray && immunizationPatientArray.length > 0) {
                    return index;
                }
            }
            //Did not find eid in patients immunization records
            return false;
        }
    }

    acceptTermsSelectedToggle(e) {
        const termsAccepted = e.target.checked;
        logUI(`MBHWeb.UI.ScheduleVaccineLanding.AcceptTerms.${termsAccepted ? "Checked" : "Unchecked"}`, new Date(), getURLPath());
        this.setState(prevState => ({
            isAcceptTermsSelected: termsAccepted,
            isError: prevState.isError && termsAccepted ? false : prevState.isError       //  so that isError gets modified if we check the terms only if prevState of isError is true
        }));
    }

    getLocation() {
        const { cityAddress, stateAddress, isCurrentLocation, curPosLatitude, curPosLongitude, state, city } = this.props;

        if (curPosLatitude && curPosLongitude && isCurrentLocation) {
            this.userLocation = `${curPosLatitude},${curPosLongitude}`;
        } else if (cityAddress, stateAddress) {
            this.userLocation = `${cityAddress},${stateAddress}&isCurrentLocation=false`;
        } else if (state && city) {
            this.userLocation = `${city},${state}&isCurrentLocation=false`;
        }
    }

    toggleErrorMessage(isError) {
        this.setState({ isError: isError });
    }

    onScheduleClick() {
        logUI("MBHWeb.UI.ScheduleVaccineLanding.ScheduleAppointment.Clicked", new Date(), getURLPath());
        const { waitingOnGeoAddress } = this.props;
        const { isAcceptTermsSelected, isGeoAddressFetch } = this.state;

        this.toggleErrorMessage(!isAcceptTermsSelected);

        if (!isAcceptTermsSelected) {
            return;
        }

        if (!isGeoAddressFetch || (isGeoAddressFetch && !waitingOnGeoAddress && waitingOnGeoAddress !== undefined)) {
            this.redirectToFindCare();
        } else {
            this.setState({ loading: true });
        }

    }

    redirectToFindCare() {
        //this.props.history.push({ pathname: '/findcare', state: { findNewDoctor: true }, searchParms: `?isVaccine=true` });
        //debugger;
        this.getLocation();
        let vaccineSearchParams = "?" + queryParams({
            xid: this.EIdByParams ? this.EIdByParams : null,
            location: this.userLocation ? this.userLocation : null
        });
        this.props.history.push({ pathname: '/findcare/vaccine', searchParms: vaccineSearchParams });
    }

    toggleAntibodyTooltip() {
        this.setState({
            antibodyTooltipOpen: !this.state.antibodyTooltipOpen
        });
    }

    toggleComponentsTooltip() {
        this.setState({
            componentsTooltipOpen: !this.state.componentsTooltipOpen
        });
    }

    toggleReactionTooltip() {
        this.setState({
            reactionTooltipOpen: !this.state.reactionTooltipOpen
        });
    }

    findXidFromProxyList(id) {
        const { myProxies, currentUser } = this.props;
        let isXidFound = false;
        let isXidIsCurrentUser = false;
        let XidName = null;
        if (myProxies && id) {
            for (let pl = 0; pl < myProxies.length; pl++) {
                let plUser = myProxies[pl];
                if (plUser && plUser.externalId && plUser.externalId.toLowerCase() === id.toLowerCase()) {
                    isXidFound = true;
                    isXidIsCurrentUser = currentUser && currentUser.externalId && currentUser.externalId.toLowerCase() === id.toLowerCase();
                    XidName = plUser && plUser.index && plUser.displayName ? getFirstName(plUser.displayName) : 'you';
                    break;
                }
            }
        }

        return { isXidFound, isXidIsCurrentUser, XidName };
    }

    render() {
        const { bffDashboardData, hasMyChart, primaryUser, currentUser, technicalHelpDeskNumber, technicalHelpDeskHours, covid19VaccineScheduleContent, covid19VaccineNotEligibleContent,
            proxyListLoading, proxyListFailure, Covid19VaccineRequireXID, Covid19VaccineEligibilityAge, myProxies, enableCovidScheduleAuthFeature, isCovidVaxScheduleEligible, headerProxyUser, showCovid19VaccineEligibililtyInfo } = this.props;
        const { Covid19VaccineBeforeProceeding } = serverData.data;
        const covidImmunizations = bffDashboardData && bffDashboardData.covidImmunizations ? bffDashboardData.covidImmunizations : [];
        const { loading, isAcceptTermsSelected } = this.state;
        let heading = 'COVID-19 Vaccine';
        let isProxy = currentUser && currentUser.index; //typeof primaryUser.externalId !== 'undefined' && currentUser.externalId !== primaryUser.externalId ? true : false;
        let displayFirstName = "";
        let consentError = this.state.isError;

        const isCurrentUserEligible = currentUser && currentUser.ageYears && Covid19VaccineEligibilityAge ? parseInt(Covid19VaccineEligibilityAge) < parseInt(currentUser.ageYears) : null;
        const { isXidFound, isXidIsCurrentUser, XidName } = this.findXidFromProxyList(this.EIdByParams);
        const learnMoreText = 'LEARN MORE ABOUT ELIGIBILITY';
        if (isProxy && currentUser && currentUser.displayName) {
            displayFirstName = getFirstName(currentUser.displayName);
        }
        if (displayFirstName && isXidFound) {
            heading += ' (' + displayFirstName + ')';
        }

        let hasVaccine = null;

        let vaccinationMsgAndLink = {
            alreadyVaccinatedMsg: '',
            learnMoreLink: ''
        };

        let vaccineShotHistory = {
            maxVaccineShots: 0,
            currentVaccineShots: 0
        };
        
        if (bffDashboardData && currentUser && covidImmunizations && covidImmunizations.length > 0) {
            vaccineShotHistory = this.getVaccineShotInformation(covidImmunizations, currentUser);
            if (vaccineShotHistory && vaccineShotHistory !== {} && vaccineShotHistory.maxVaccineShots !== 0) {
                const learnMoreLink = 'https://www.bswhealth.com/covid-vaccine';
                const currentUserName = currentUser && currentUser.displayName || null;
                const maxVaccineShots = vaccineShotHistory && vaccineShotHistory.maxVaccineShots || 0;
                const currentVaccineShots = vaccineShotHistory && vaccineShotHistory.currentVaccineShots || 0;

                if (!currentUserName) {
                    return null;
                }

                if (maxVaccineShots > 0 && currentVaccineShots >= maxVaccineShots) {
                    vaccinationMsgAndLink.alreadyVaccinatedMsg = `Congratulations, ${displayFirstName ? displayFirstName + " is" : "you're"} vaccinated!`;
                    vaccinationMsgAndLink.learnMoreLink = "";
                }
                //Vaccines in progress
                if (currentVaccineShots < maxVaccineShots) {
                    vaccinationMsgAndLink.alreadyVaccinatedMsg = `${displayFirstName ? displayFirstName + " has received the first vaccine!" : "You've received your first vaccine!"}`;
                    vaccinationMsgAndLink.learnMoreLink = learnMoreLink;
                }

                if (vaccinationMsgAndLink && vaccinationMsgAndLink.alreadyVaccinatedMsg !== '') {
                    hasVaccine = true;
                }
                else { hasVaccine = false; }
            }

        }
        if (hasMyChart && ((enableCovidScheduleAuthFeature === false || (enableCovidScheduleAuthFeature && isCovidVaxScheduleEligible)) && ((!Covid19VaccineRequireXID && !isProxy) || (Covid19VaccineRequireXID && this.EIdByParams && isXidIsCurrentUser)))) {
            heading = `${isProxy ? ((currentUser && getFirstName(currentUser.displayName)) + ' is ') : 'You’re'} Eligible to Schedule the COVID-19 Vaccine`;
        }

        let XidNotFoundMessage = (<div className="col-12 maxWidth-content">
            <p>At this time, we are not able to verify {displayFirstName ? `${displayFirstName}’s` : "your"} vaccine eligibility.</p>
            {covid19VaccineNotEligibleContent && <StaticHtmlContent content={covid19VaccineNotEligibleContent} />}
        </div>);

        let XidFoundAndNotCurrentUserMsg = (<div className="col-12 maxWidth-content">
            This link was intended for {XidName ? `${XidName}` : "you"}. To view vaccine scheduling options for {XidName && XidName !== "you" ? `${XidName}` : "yourself"}, please switch to {XidName && XidName !== "you" ? "their" : "your"} account.
        </div>);

        let userInEligibleMsg = (<div className="col-12 maxWidth-content">
            Based on the birth date on file, {displayFirstName ? `${displayFirstName} is` : "you are"} too young to receive the vaccine per the CDC's guidance on allocation.
        </div>);

        return (
            hasVaccine ?
                <div className="container-fluid body-content schedule-vaccine-vaccinated-container">
                    <div className="row schedule-vaccine-vaccinated-container__block">
                        <div className="col schedule-vaccine-vaccinated-container__img">
                            <span className="svg-nurse" />
                        </div>
                        <div className="col align-middle schedule-vaccine-vaccinated-container__body">
                            <div className="vaccinated-message">
                                <strong>{vaccinationMsgAndLink.alreadyVaccinatedMsg}</strong>
                                <div className="learn-more-link">
                                    <br />
                                    {vaccinationMsgAndLink.learnMoreLink && <a className="btn btn-primary" href={vaccinationMsgAndLink.learnMoreLink} target="_blank" onClick={(e) => { logUI("MBHWeb.UI.ScheduleVaccineLanding.LearnMore.Clicked", new Date(), Tools.getURLPath()); }}>{learnMoreText}</a>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className="container-fluid body-content schedule-vaccine-landing-container">
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            <h1 className="page-heading">{heading}</h1>
                            {showCovid19VaccineEligibililtyInfo && hasMyChart && ((Covid19VaccineRequireXID && isXidIsCurrentUser) || (!Covid19VaccineRequireXID && !isProxy)) &&
                                <div className="page-subheading">These are some of the current criteria for eligibility.</div>
                            }
                        </div>
                    </div>
                    {
                        ((!Covid19VaccineRequireXID || (Covid19VaccineRequireXID && this.EIdByParams)) && ((proxyListLoading && (!currentUser || !headerProxyUser)) || ((!currentUser || !headerProxyUser) && !proxyListFailure))) ? <Spinner /> :
                            ((Covid19VaccineRequireXID && hasMyChart && (!this.EIdByParams || (!isXidFound || !isXidIsCurrentUser))) || (!Covid19VaccineRequireXID && (hasMyChart && !isCurrentUserEligible)))
                                ? <div className="row schedule-vaccine-proxy">
                                    {(!isXidFound || !Covid19VaccineRequireXID) ? isCurrentUserEligible === false ? userInEligibleMsg : XidNotFoundMessage : XidFoundAndNotCurrentUserMsg}
                                </div>
                                : <> {hasMyChart
                                    ? ((enableCovidScheduleAuthFeature === false || (enableCovidScheduleAuthFeature && isCovidVaxScheduleEligible)) && ((!Covid19VaccineRequireXID && !isProxy) || (Covid19VaccineRequireXID && this.EIdByParams && isXidIsCurrentUser))) ?
                                        <>
                                            {Covid19VaccineBeforeProceeding &&
                                                <div className="row before-proceeding-banner">
                                                    <div className="col-12 maxWidth-content">
                                                        <div className="before-proceeding-title">
                                                            <span className="icon-info-filled"></span> Before proceeding
                                    </div>
                                                        <p>Any of the following will prohibit you from receiving the COVID-19 vaccine.</p>
                                                        <div className="before-proceeding-body">
                                                            <ul className="angle-bullets">
                                                                <li>Within the past 14 days you've tested positive for COVID-19 or have been in contact with someone who has COVID-19.</li>
                                                                {/**<li>You've had a vaccine within the past 14 days.</li>
                                                                <li>You've had <span className="tooltip-on-hover" id="antibody-hover">passive antibody therapy as a treatment</span> for COVID-19 within the past 90 days.</li>
                                                                <Tooltip placement="top" isOpen={this.state.antibodyTooltipOpen} target="antibody-hover" className="covid-vaccine-tooltip" toggle={this.toggleAntibodyTooltip}>Examples include monoclonal antibodies or convalescent plasma</Tooltip>**/}
                                                                <li>You've had an <span className="tooltip-on-hover" id="reaction-hover">IMMEDIATE</span> or SEVERE ALLERGIC REACTION to a COVID-19 vaccine or any of <span className="tooltip-on-hover" id="components-hover">its components.</span></li>
                                                                <Tooltip placement="top" isOpen={this.state.componentsTooltipOpen} target="components-hover" className="covid-vaccine-tooltip" toggle={this.toggleComponentsTooltip}>Examples include polyethylene glycol (“PEG”), polysorbate or polyoxyl 35 Castor oil</Tooltip>
                                                            <Tooltip placement="top" isOpen={this.state.reactionTooltipOpen} target="reaction-hover" className="covid-vaccine-tooltip" toggle={this.toggleReactionTooltip}>Within 4 hours</Tooltip>
                                                            </ul>
                                                            <div>
                                                                <label className="checkbox-container">
                                                                    <input
                                                                        type="checkbox" name="eligibleChecklist"
                                                                        checked={isAcceptTermsSelected}
                                                                        onChange={this.acceptTermsSelectedToggle}
                                                                    />
                                                                    <span className="checkmark" />
                                                                    <span className="checkbox-label">None of these apply to me and I am able to receive the COVID-19 vaccine.</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            }

                                            <div className="row schedule-vaccine-banner">
                                                <div className="col-12 maxWidth-content">
                                                    {Covid19VaccineBeforeProceeding ? "Additional Information" : "Before proceeding, please know:"}
                                                </div>
                                            </div>
                                            <div className="row schedule-vaccine-info">
                                                <div className="col-12 maxWidth-content">
                                                    {covid19VaccineScheduleContent
                                                        ? <StaticHtmlContent content={covid19VaccineScheduleContent} />
                                                        : <ul className="angle-bullets">
                                                            <li>All Texans 12 and up are eligible to receive the COVID-19 vaccine.</li>
                                                            <li>If you are receiving a COVID vaccine requiring a second dose, your second dose will be administered within the CDC-recommended window of up to six weeks following your first dose, and your appointment will be scheduled in person at the time of your first vaccination.</li>
                                                            <li>If you received your first dose at a non-BSWH location and you need a second dose to complete your series, please call our vaccine line at <a href="tel:1.844.279.8222" className="phone-link">1.844.BSW.VACC.</a></li>
                                                            <li>For more information, visit Baylor Scott & White Health's <a href="https://www.bswhealth.com/covid-vaccine" target="_blank">COVID-19 FAQ page</a>.</li>
                                                        </ul>
                                                    }
                                                </div>
                                            </div>
                                            <div className="row schedule-vaccine-btn">
                                                <div className="col-12 maxWidth-content">
                                                    {consentError &&
                                                        <div className="error-msg">
                                                            Please review and consent to the terms in the Before Proceeding section<br />
                                                        </div>
                                                    }
                                                    <button className="btn btn-primary" type="button" onClick={this.onScheduleClick}>Schedule an Appointment</button>
                                                </div>
                                            </div>
                                        </> :
                                        <div className="row">
                                            {XidNotFoundMessage}
                                        </div>
                                    : <div className="row">
                                        <div className="col-12 maxWidth-content">
                                            To access online scheduling, link your BSWH medical record by contacting the MyBSWHealth technical help desk {technicalHelpDeskHours} at <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.
                            </div>
                                    </div>}
                                </>
                    }
                    {loading && <Spinner />}
                </div>
        );
    }

}
const mapStateToProps = (state) => {
    let userCity = "";
    let userState = "";
    if (!state.healthSource.fetchingUserAddress && state.healthSource.userAddress && state.healthSource.userAddress.length > 0) {
        userCity = state.healthSource.userAddress[0] ? state.healthSource.userAddress[0].City : userCity;
        userState = state.healthSource.userAddress[0] ? state.healthSource.userAddress[0].State : userState;
    }
    const pl = [];
    if (state.domain.pl) {
        state.domain.pl.forEach((proxy) => {
            pl.push(d.hydrateProxyUser(proxy));
        });
    }
    return {
        bffDashboardData: state.dashboard && state.dashboard.bffDashboardData && state.dashboard.bffDashboardData ? state.dashboard.bffDashboardData.data : [],
        hasMyChart: state.domain.hm,
        myProxies: pl,
        proxyListLoading: state.memberships.proxyListLoading,
        proxyListFailure: state.memberships.proxyListFailure,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentUser: d.hydrateProxyUser(state.domain.cu),
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours:"",
        latitude: state.domain.lt,
        longitude: state.domain.ln,
        isCurrentLocation: state.locations.isCurrentLocation,
        curPosLatitude: state.locations.latitude,
        curPosLongitude: state.locations.longitude,
        cityAddress: state.locations.city,
        stateAddress: state.locations.state,
        waitingOnGeoAddress: state.locations.waitingOnGeoAddress,
        geoAddressError: state.locations.geoAddressError,
        city: userCity,
        state: userState,
        userName: state.sso.userDetails.userName,
        fetchingUserAddress: state.healthSource.fetchingUserAddress,
        isLoggedIn: state.domain.li,
        headerProxyUser: state.memberships.currentUser,
        Covid19VaccineEligibilityAge: state.session.serverData && state.session.serverData.Covid19VaccineEligibilityAge ? state.session.serverData.Covid19VaccineEligibilityAge : "",
        Covid19VaccineRequireXID: state.session.serverData && state.session.serverData.Covid19VaccineRequireXID ? state.session.serverData.Covid19VaccineRequireXID : false,
        showCovid19VaccineEligibililtyInfo: state.session.serverData && state.session.serverData.showCovid19VaccineEligibililtyInfo ? state.session.serverData.showCovid19VaccineEligibililtyInfo : false,
        covid19VaccineScheduleContent: state.session.serverData && state.session.serverData.covid19VaccineScheduleContent ? state.session.serverData.covid19VaccineScheduleContent : "",
        covid19VaccineNotEligibleContent: state.session.serverData && state.session.serverData.covid19VaccineNotEligibleContent ? state.session.serverData.covid19VaccineNotEligibleContent : "",
        isCovidVaxScheduleEligible: state.memberships.hasAuthorizedFeatureSchedCovidVax,
        enableCovidScheduleAuthFeature: state.session.serverData && state.session.serverData.enableCovidScheduleAuthFeature ? state.session.serverData.enableCovidScheduleAuthFeature : false
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUserAddress: (userName) => {
            dispatch({
                type: types.GET_USER_ADDRESS_START, userName: userName
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleVaccineLanding);